import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: theme.spacing(0)
  },
  editIcon: {
    width: 24,
    height: 24
  },
  notificationText: {
    display: 'flex',
    direction: 'column',
    paddingLeft: theme.spacing(8),
    paddingTop: theme.spacing(2),
    fontSize: 12,
    fontWeight: 400
  },
  icon: {
    marginBottom: theme.spacing(16)
  }
}));

export default useStyles;
